import { ErrorOutlineRounded } from "@mui/icons-material";
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import { DateRangePickerComponent, DateRangePickerComponentProps } from "../../components/DateRangePickerComp";
import { MainContainer } from "../../components/MainContainerComp";
import { Disclaimer } from "./components/Disclaimer";
import { buttonContainerStyle, disclaimerContainerStyle, disclaimerContentStyle, disclaimerStyle, subHeaderStyle, descriptionStyle } from "./styled";

export interface IPayrollHistoryProps {
  dateRangePickerComponentProps: DateRangePickerComponentProps,
  onView: () => void;
  disabledView: boolean;
  onRunReport: () => void;
  onShowDetails: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showDetailsChecked: boolean;
  showDisclaimer: boolean;
  onShowDisclaimer: () => void;
}

export const PayrollHistory: React.FC<IPayrollHistoryProps> = ({
  dateRangePickerComponentProps,
  onView,
  disabledView,
  onRunReport,
  onShowDetails,
  showDetailsChecked,
  showDisclaimer,
  onShowDisclaimer
}) => (
  <MainContainer>
    {showDisclaimer &&
      <Box sx={disclaimerContainerStyle}>
        <Box sx={disclaimerContentStyle}>
          <Disclaimer handleClick={onShowDisclaimer} />
        </Box>
      </Box>
    }
    <Box
      sx={disclaimerStyle}
      onClick={onShowDisclaimer}
    >
      <ErrorOutlineRounded sx={{ marginRight: "3px" }} />
      <Typography data-automation="disclaimer-label">Disclaimer</Typography>
    </Box>
    <Typography sx={descriptionStyle} data-automation="payroll-history-description">
      Enter Start and End Dates and tap [View] to generate your Payroll History report
    </Typography>
    <Typography sx={descriptionStyle} data-automation="run-report-description">You can use the [Run Report] button to produce the PDF version</Typography>
    <Typography sx={subHeaderStyle} className="sub-title" data-automation="date-range-header">
      Payroll History Date Range
    </Typography>
    <DateRangePickerComponent {...dateRangePickerComponentProps} />
    <Grid sx={{ justifyContent: 'center' }} container>
      <Grid sx={buttonContainerStyle} item xs={12} md={8}>
        <Button
          sx={{ mb: 1, width: '110px' }}
          onClick={onView}
          disabled={disabledView}
          variant="contained"
          size="medium"
          data-automation="view-btn"
        >
          View
        </Button>
      </Grid>
      <Grid sx={buttonContainerStyle} item xs={12} md={8}>
        <Button
          onClick={onRunReport}
          disabled={disabledView}
          variant="contained"
          size="medium"
          data-automation="view-btn"
        >
          Run Report
        </Button>
      </Grid>
      <Grid sx={buttonContainerStyle} item xs={12} md={8}>
        <FormControl sx={{ mt: 1 }}>
          <FormControlLabel
            control={<Checkbox
              checked={showDetailsChecked}
              onChange={onShowDetails}
            />}
            label='Show Details in Report'
            data-automation="show-report-details"
          />
        </FormControl>
      </Grid>
    </Grid>
  </MainContainer>
)
